<template>
  <div
    v-bind="$attrs"
    class="form-group"
    :class="{ 'has-error': errors.has(name) }"
  >
    <b-form-radio-group class="mb-1" v-model="selectedType">
      <b-form-radio value="cpf">CPF</b-form-radio>
      <b-form-radio value="cnpj">CNPJ</b-form-radio>
    </b-form-radio-group>

    <the-mask
      :id="name"
      :name="name"
      class="form-control"
      :placeholder="$t('type_cpf_cnpj')"
      :mask="documentMask"
      :value="value"
      @input="onInput"
      v-validate="validationRule"
      :data-vv-name="name"
    />

    <small v-show="errors.has(name)" class="form-text text-muted">
      {{ errors.first(name) }}
    </small>
  </div>
</template>

<script>
import { maskByDocument } from "@/lib/staticMask";

export default {
  inject: ["$validator"],

  props: {
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "cpf_cnpj",
    },
    type: {
      type: String,
      default: "cpf",
    },
  },

  data() {
    return {
      selectedType: this.type,
    };
  },

  computed: {
    documentMask() {
      return maskByDocument(this.selectedType);
    },

    validationRule() {
      return this.selectedType === "cpf"
        ? "required|digits:11"
        : "required|cnpj_alphanumeric";
    },
  },

  methods: {
    onInput(value) {
      this.$emit("input", value.toUpperCase());
    },
  },

  watch: {
    selectedType(type) {
      this.$emit("update:type", type);
      this.$emit("change-type", type);
    },
  },
};
</script>
